module.exports = __webpack_public_path__ + "media/images/constancia_assistencia-f63ed5c7.png";